import styled from "styled-components";
import imgDesktop from "assets/images/orofacial/desktop.jpg";
import imgMobile from "assets/images/orofacial/mobile.jpg";

import { colors, colorScheme, fonts } from "styles";
export { Button } from "styles/styled-components";

export const Container = styled.a`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  padding: 0;
  height: auto;
  background: url(${imgDesktop}) no-repeat top left;
  background-size: cover;
  cursor: pointer;
  @media screen and (max-width: 1300px) {
    max-height: auto;
  }
  @media screen and (max-width: 900px) {
    background: url(${imgMobile}) no-repeat top center;
    background-size: cover;
    height: auto;
  }
  @media screen and (max-width: 580px) {
    background: url(${imgMobile}) no-repeat top center;
    background-size: 100% auto;
    height: auto;
  }
`;

export const AreaCta = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 450px;
  height: auto;
  padding: 15px;
  z-index: 20;
  bottom: 120px;
  right: 3%;

  @media screen and (max-width: 1770px) {
    right: 5%;
  }
  @media screen and (max-width: 1675px) {
    right: 0;
  }
  @media screen and (max-width: 1525px) {
    right: inherit;
    bottom: inherit;
    margin-bottom: 20px;
  }
  @media screen and (max-width: 580px) {
    padding: 0 15px;
    margin-bottom: 10px;
  }
`;
export const GroupText = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 50px;

  @media screen and (max-width: 1382px) {
    margin-bottom: 20px;
  }
  p {
    font-family: ${fonts.SourceSansProRegular};
    font-size: 18px;
    color: #fff;
    line-height: 1.4em;
    @media screen and (max-width: 580px) {
      text-align: center;
      font-size: 14px;
    }
  }
`;
export const GroupButtons = styled.div`
  display: flex;
  width: 100%;
  height: auto;
  column-gap: 20px;
  align-items: center;
  justify-content: center;
`;
